function updatePrice() {
  const parent_items = document.querySelectorAll('[data-isparent="true"]')

  parent_items.forEach(function (item, index) {
    price_adjustment = 0.0
    selection_id = item.dataset.selectionid
    let child_items = document.querySelectorAll(
      '[data-selectionid="' + selection_id + '"]'
    )

    if (child_items.length <= 1) {
      item.classList.add("no-children")
    } else {
      child_items.forEach(function (child) {
        if (child.dataset.isparent != "true") {
          let price = child.querySelector(".cart__price").innerText
          let priceInt = price.replace("$", "")
          price_adjustment = price_adjustment + parseFloat(priceInt)
        }
      })

      // console.log(price_adjustment)

      if (price_adjustment != 0.0) {
        let parent_price = item.querySelector(".cart__price").innerText
        let priceInt = parent_price.replace("$", "")
        parent_price = parseFloat(priceInt)
        parent_price = parent_price + price_adjustment

        let priceDisplay = document.querySelectorAll(".updated__price")
        priceDisplay[index].innerText = "$" + parent_price.toFixed(2)
      }
    }
  })
}

document.addEventListener("cart:rendered", function (evt) {
  updatePrice()
})

window.addEventListener("load", event => {
  updatePrice()
})
